export default "/50f517735fec46580f19aae3e56e9fe21614ea75/bce1c79c076cfd26ce49a1f2fa85ca50.svg";